import { render, staticRenderFns } from "./formKemajuanPerizinan.vue?vue&type=template&id=470dfaee&"
import script from "./formKemajuanPerizinan.vue?vue&type=script&lang=js&"
export * from "./formKemajuanPerizinan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports